import React, { Component } from 'react';

import styled from 'styled-components';

import Box from '../atoms/Box/Box';
import ComparePlans from '../molecules/ComparePlans';
import LicenseFeatures from '../molecules/LicenseFeatures';
import Universities from '../molecules/Universities';
import CardSubscription from '../organisms/CardSubscription/CardSubscription';
import ComparisonChart from '../organisms/ComparisonChart';
import Presentation from '../organisms/Presentation';

import { CA_ICON } from '@shared/markup/constants';
import { Currency } from '@shared/interfaces/currency';
import { I18nTranslation } from '@shared/interfaces/i18n';
import { PricingCard } from '@shared/interfaces/pricing-card';
import { Product } from '@shared/interfaces/product';
import { Sale } from '@shared/interfaces/sale';
import { _scrollToElement } from '@shared/animate/functions';
import { breakpoint } from 'theme';
import { withTranslation } from 'i18n';

const SubscriptionsWrapper = styled.div`
  background-color: ${props => props.theme.colors.cornflowerBlue};
  padding: 4em 1em;
`;

const Subscriptions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${breakpoint.m`
    flex-direction: row;
    flex-wrap: wrap;
  `}
`;

const Title = styled.div`
  line-height: 1.16;
  font-size: 2em;
  font-weight: bold;
  margin-bottom: 1rem;
  color: ${props => props.theme.colors.white};
  text-align: center;

  ${breakpoint.m`
    font-size: 3.25em;
    margin-bottom: 2rem;
  `}
`;

const SubTitle = styled.div`
  line-height: 1.5;
  color: ${props => props.theme.colors.white};
  text-align: center;
  font-size: 1.25em;
  margin-bottom: 2rem;

  ${breakpoint.m`
    font-size: 1.5em;
    margin-bottom: 4rem;
  `}
`;

const SubTitleExtend = styled(SubTitle)`
  margin-bottom: 4rem;
`;

type OfferTemplateProps = {
  application?: Product;
  currency?: Currency;
  isLoadingApps?: boolean;
  onAddToBasket?: () => void;
  isAddingToBasket?: boolean;
  sale?: Sale;
  onShowChangePurchasedSubscriptionPopup?: () => void;
  prices: PricingCard[];
  t: I18nTranslation;
  isPromo?: boolean;
};

class OfferTemplate extends Component<OfferTemplateProps> {
  priceFormat = (symbol, price) => {
    return `${symbol}${price.toFixed(2)}`;
  };

  scrollToSubs = () => {
    const elem: HTMLElement = document.querySelector('#subscriptions-box');
    _scrollToElement(elem);
  };

  render() {
    const {
      application,
      prices,
      sale,
      currency,
      isLoadingApps,
      isAddingToBasket,
      isPromo,
      onAddToBasket,
      onShowChangePurchasedSubscriptionPopup,
      t,
    } = this.props;

    const plansWithPrices = application.subscriptions.reduce(
      (acc, subscription) => {
        const information = prices.find(
          price => price.bundle === subscription.bundle
        );

        return [
          ...acc,
          {
            subscription,
            information,
          },
        ];
      },
      []
    );

    // TODO: При избавлении от платформ вынести эту логику в функцию и также в PricingTemplate
    const comparisonSubscriptions = application.subscriptions.map(
      subscription => ({
        name: subscription.name,
        icon: subscription.card.icon,
        bundle: subscription.bundle,
      })
    );
    const discountPercent = sale.discount_percent;
    const imageUrl = sale.image;

    let hasSaleArray = [false];
    const presentation = (
      // @ts-ignore TODO: resolve the issue
      <Presentation
        appName={application.styled_name}
        appIcon={CA_ICON}
        onClickScroll={this.scrollToSubs}
        discountPercent={discountPercent}
        isPromo={isPromo}
        imageUrl={imageUrl}
      />
    );

    return (
      <Box backgroundColor="white">
        {presentation}
        <SubscriptionsWrapper id="subscriptions-box">
          {sale.discount_percent && (
            <Title>{t('cardSectionTitle', { discountPercent })}</Title>
          )}
          {sale.discount_percent && (
            <SubTitle>{t('cardSectionSubTitle', { discountPercent })}</SubTitle>
          )}

          <Subscriptions>
            {plansWithPrices.map(item => {
              const subscription = item.subscription;
              const information = item.information.selected;
              const regPrice = this.priceFormat(
                currency.symbol,
                information.regPrice
              );
              const salePrice = this.priceFormat(
                currency.symbol,
                information.price
              );
              const hasSale = information.price !== information.regPrice;
              if (hasSale) {
                hasSaleArray = [...hasSaleArray, true];
              }

              return (
                <CardSubscription
                  key={subscription.id}
                  option={subscription.card}
                  hasSale={hasSale}
                  stringRegPrice={regPrice}
                  stringSalePrice={salePrice}
                  subscription={subscription}
                  application={application}
                  currencyISO={currency.iso}
                  isLoadingApps={isLoadingApps}
                  onAddToBasket={onAddToBasket}
                  isAddingToBasket={isAddingToBasket}
                  onShowChangePurchasedSubscriptionPopup={
                    onShowChangePurchasedSubscriptionPopup
                  }
                />
              );
            })}
          </Subscriptions>

          {hasSaleArray.includes(true) && (
            <SubTitleExtend>{t('saleTip')}</SubTitleExtend>
          )}

          <ComparePlans
            onClick={this.scrollToSubs.bind(this, 'features-table')}
          />
        </SubscriptionsWrapper>
        <ComparisonChart
          title="Comparison chart"
          subTitle={null}
          subscriptions={comparisonSubscriptions}
          features={application.comparison}
        />
        <LicenseFeatures />
      </Box>
    );
  }
}

export default withTranslation('offer')(OfferTemplate);
